const mediaTypes = {
    storageSiteImage: {
        accept: ['image/jpeg', 'image/png', 'image/webp']
    },
    storageSiteVideo: {
        accept: ['video/mp4', 'video/webm', 'video/mpeg', 'video/ogg', 'video/quicktime']
    },
    storageSiteDocument: {
        accept: ['application/pdf']
    },
    messageImage: {
        accept: ['image/jpeg', 'image/png', 'image/webp']
    },
    ownerLogotypeImage: {
        accept: ['image/jpeg', 'image/png', 'image/webp']
    },
    tiptapEditorImage: {
        accept: ['image/jpeg', 'image/png', 'image/webp']
    }
};

Object.keys(mediaTypes).forEach(key => {
    mediaTypes[key].key = key;
});

export default mediaTypes;
